import BottomPanel from '@ubnt/link-core-ui/components/BottomPanel/layout/BottomPanel';
import BottomPanelContent from '@ubnt/link-core-ui/components/BottomPanel/layout/BottomPanelContent';
import { memo } from 'react';
import { clsx } from 'clsx';

import { useSelector } from 'app/store';
import { settingsIsCountryRestrictedSelector } from 'modules/settings/slice';
import { ApDevicePanelProps } from './ApDevicePanel';
import { ClientDevicePanelProps } from './ClientDevicePanel';
import { WifiPanelResultsDisplayProps } from './WifiPanelResultsDisplay';

import classes from './WifiBottomPanel.module.scss';
import devicePanelClasses from './DevicePanel.module.scss';

interface WifiBottomPanelProps {
  apId: string;
  clientId: string;
  linkId: string;

  ApDevicePanel: React.ElementType<Partial<ApDevicePanelProps>>;
  ClientDevicePanel: React.ElementType<Partial<ClientDevicePanelProps>>;
  PanelResultsDisplay: React.ElementType<Partial<WifiPanelResultsDisplayProps>>;
}

const WifiBottomPanel = (props: WifiBottomPanelProps) => {
  const { apId, clientId, linkId, ApDevicePanel, ClientDevicePanel, PanelResultsDisplay } = props;
  const isRestrictedCountry = useSelector(settingsIsCountryRestrictedSelector);

  return (
    <BottomPanel
      className={classes.WifiBottomPanel}
      contentClassName={clsx(classes.bottomPanelContent, isRestrictedCountry && classes.nonono)}
      leftId={apId}
      linkId={linkId}
      rightId={clientId}
      expanded
    >
      <BottomPanelContent className={clsx(classes.content, devicePanelClasses.desktop)}>
        <ApDevicePanel />
        <PanelResultsDisplay />
        <ClientDevicePanel />
      </BottomPanelContent>
    </BottomPanel>
  );
};

const MemoizedWifiBottomPanel = memo(WifiBottomPanel);

export default MemoizedWifiBottomPanel;
